const ExhibitionTitle = () => ({
  init() {
    this.animateFontOnScroll(this.$root);
  },

  animateFontOnScroll(el) {
    let vFont = el;

    function createObserver() {
      let observer;
      let options = {
        root: null,
        rootMargin: '0px 0px -50% 0px',
        threshold: buildThresholdList()
      };
      observer = new IntersectionObserver(handleIntersect, options);
      observer.observe(vFont);
    }

    function buildThresholdList() {
      let thresholds = [];
      let numSteps = 100;
      const delay = 0.01;

      for (let i = 1.0; i <= numSteps; i++) {
        let ratio = i / numSteps - delay;
        thresholds.push(Math.max(0, Math.min(1, ratio)));
      }

      thresholds.push(0);
      return thresholds;
    }

    function handleIntersect(entries) {
      entries.forEach((entry) => {
        let axisValue = Math.max(
          0,
          Math.min(100, entry.intersectionRatio * 100)
        ).toFixed(2);
        vFont.style.fontVariationSettings = `"rxad" ${axisValue}`;
      });
    }
    createObserver();
  }
});

export default ExhibitionTitle;
